import '@/Utils/DateLocale';
import dayjs from 'dayjs';
export function getRelativeTimeString(date) {
    return dayjs(date).fromNow();
}
